<template>
  <div class="c-text-block">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'text-block',

  props: ['content']
}
</script>

<style lang="scss">
.c-text-block {
  margin: 0 0 1.5em;
  font-family: $font-frutiger-light;
  line-height: 1.444;
  font-size: 18px;

  * {
    color: $colour-nhs-dark-grey !important;
  }

  a {
    color: $colour-nhs-core-blue !important;
    text-decoration: underline;
  }

  *:first-of-type {
    margin-top: 0;
  }

  ul {
    list-style-type: none;
    li {
      &:before {
        content: '\2022';
        color: $colour-nhs-blue;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }
    }
  }
}
</style>
